import { render, staticRenderFns } from "./AgentPaymentTable.vue?vue&type=template&id=94f1f6f2&scoped=true&"
import script from "./AgentPaymentTable.vue?vue&type=script&lang=ts&"
export * from "./AgentPaymentTable.vue?vue&type=script&lang=ts&"
import style0 from "./AgentPaymentTable.vue?vue&type=style&index=0&id=94f1f6f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f1f6f2",
  null
  
)

export default component.exports